export default __webpack_public_path__ + "static/media/male-profile.ab404f6d.svg";